import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useI18n } from "../../i18n";

// Délai avant d'afficher la roue : un morceau déjà en cache arrive en
// quelques millisecondes, on évite alors un clignotement inutile.
const DELAI_AFFICHAGE_MS = 250;

/**
 * Repli léger affiché pendant qu'une page chargée à la demande arrive
 * (Suspense). Accessible : zone « status » annoncée par les lecteurs d'écran
 * seulement si l'attente dure (le texte n'apparaît qu'après le délai).
 *
 *   pleinePage : occupe l'écran (première page d'administration ouverte)
 *   sinon      : bloc dans la zone de contenu (la barre latérale reste)
 */
export default function RepliChargement({ pleinePage = false }) {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const minuteur = setTimeout(() => setVisible(true), DELAI_AFFICHAGE_MS);
    return () => clearTimeout(minuteur);
  }, []);

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="repli-chargement"
      className={
        pleinePage
          ? "min-h-screen flex items-center justify-center"
          : "flex items-center justify-center py-24"
      }
      style={pleinePage ? { background: "var(--trm-bg)" } : undefined}
    >
      {visible && (
        <>
          <Loader2
            aria-hidden="true"
            className="h-8 w-8 motion-safe:animate-spin"
            style={{ color: "var(--trm-muted)" }}
          />
          <span className="sr-only">{t("common.loading")}</span>
        </>
      )}
    </div>
  );
}
